<app-ui-preloader
  [display]="true"
  *ngIf="loading.appLoading | async; else appRoutes"
></app-ui-preloader>
<ng-template #appRoutes>
  <router-outlet></router-outlet>
</ng-template>
<!-- <ngx-guided-tour></ngx-guided-tour> -->
<tour-step-template></tour-step-template>
<app-modal-container></app-modal-container>